var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 8,
  y: 17,
  width: 29,
  height: 23,
  fill: "#c3ccd2"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 11,
  y: 20.5,
  width: 4.2,
  height: 3.8,
  fill: "#8fb6c9"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 17.4,
  y: 20.5,
  width: 4.2,
  height: 3.8,
  fill: "#8fb6c9"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 23.8,
  y: 20.5,
  width: 4.2,
  height: 3.8,
  fill: "#8fb6c9"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 30.2,
  y: 20.5,
  width: 4.2,
  height: 3.8,
  fill: "#8fb6c9"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 11,
  y: 27,
  width: 4.2,
  height: 3.8,
  fill: "#8fb6c9"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 17.4,
  y: 27,
  width: 4.2,
  height: 3.8,
  fill: "#8fb6c9"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 23.8,
  y: 27,
  width: 4.2,
  height: 3.8,
  fill: "#8fb6c9"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 30.2,
  y: 27,
  width: 4.2,
  height: 3.8,
  fill: "#8fb6c9"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 11,
  y: 33.5,
  width: 4.2,
  height: 3.8,
  fill: "#8fb6c9"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 17.4,
  y: 33.5,
  width: 4.2,
  height: 3.8,
  fill: "#8fb6c9"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 23.8,
  y: 33.5,
  width: 4.2,
  height: 3.8,
  fill: "#8fb6c9"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 30.2,
  y: 33.5,
  width: 4.2,
  height: 3.8,
  fill: "#8fb6c9"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 6.5,
  y: 14.5,
  width: 32,
  height: 2.6,
  rx: 1,
  fill: "#5f7d95"
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  x: 11,
  y: 8.5,
  width: 10.5,
  height: 6,
  rx: 1,
  fill: "#dfe6ec"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "m13.2 10v3",
  fill: "none",
  stroke: "#9aa7b0",
  strokeWidth: 1
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "m15.7 10v3",
  fill: "none",
  stroke: "#9aa7b0",
  strokeWidth: 1
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "m18.2 10v3",
  fill: "none",
  stroke: "#9aa7b0",
  strokeWidth: 1
});

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  x: 27.5,
  y: 9.8,
  width: 2.6,
  height: 4.7,
  fill: "#8f9ba3"
});

var _ref21 = /*#__PURE__*/React.createElement("rect", {
  x: 26.4,
  y: 8.6,
  width: 4.8,
  height: 1.6,
  rx: 0.8,
  fill: "#8f9ba3"
});

function SvgCeilingRoof(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 45 45",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCeilingRoof);
export default __webpack_public_path__ + "static/media/ceiling-roof.9cd1394a384a070e4f443f9b17bb9c2d.svg";
export { ForwardRef as ReactComponent };